import { CardBrandDetails } from "@swiggy-private/payment-types";

export const defaultCardBrandDetails: CardBrandDetails = {
    cardBrand: null,
    cardIcon: null,
    url: null,
    tokenizeSupport: null,
    cardBin: null,
    disableForTenant: null,
    disableForTenantReason: null,
    country: null,
    enabled: true,
    disableReason: null,
};

export const CARD_BRAND = {
    SODEXO: "SODEXO",
    AMEX: "AMEX",
};

export const DEFAULT_MAX_IOS_VERSION_FOR_JUSPAY_REDIRECT_FLOW = 419;
export const DEFAULT_MAX_IOS_VERSION_FOR_JUSPAY_REDIRECT_FLOW_DASH = 422;
export const DEFAULT_MAX_IOS_VERSION_FOR_JUSPAY_REDIRECT_FLOW_OTHER_BLS = 430;
export const CARD_BIN_NUMBER_MAX_LIMIT = 9;

export enum CARD_COUNTRY {
    INDIA = "india",
}

export const MINIMUM_CARDNUMBER_LENGTH = 12;

export const CARD_OFFER_STATE = {
    OFFER_FETCH_SUCCESSFUL: "OFFER_FETCH_SUCCESSFUL",
    OFFER_NOT_AVAILABLE: "OFFER_NOT_AVAILABLE",
    OFFER_REWARDS_APPLY_SUCCESSFUL: "OFFER_REWARDS_APPLY_SUCCESSFUL",
    OFFER_REWARDS_NOT_AVAILABLE: "OFFER_REWARDS_NOT_AVAILABLE",
};

export const SKIP_CLIENT_CARD_VALIDATION = "skip_client_card_validation";
